export default __webpack_public_path__ + "static/media/Wheel-Wedge-Red.c1658e0c.png";